import { render, staticRenderFns } from "./DoctorCardC.vue?vue&type=template&id=2a8d1e44&scoped=true"
import script from "./DoctorCardC.vue?vue&type=script&lang=js"
export * from "./DoctorCardC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8d1e44",
  null
  
)

export default component.exports